/* eslint-disable @next/next/no-img-element */
import Image from 'next/image'
import { isFastagLandingWidget } from '@helpers/vasLandingPageHelper'
import styles from './challanKeyFeatures.module.scss'

const ChallanKeyFeatures = ({ content }) => {
  const keyFeatures = content?.KeyFeatures || []
  const isFastagPage = isFastagLandingWidget(content?.widget)

  return (
    <div className={styles.keyFeaturesContainer}>
      {keyFeatures?.map(item => {
        const iconUrl = item?.KeyFeatureIcon?.data?.attributes?.url
        const description = item?.keyFeatureServiceProvided

        return (
          <div className={`${styles.keyFeatureItem} ${isFastagPage ? styles.specialBackground : ''}`} key={item?.id}>
            {iconUrl && (
              <Image src={iconUrl} alt="Key Feature Icon" width={32} height={32} className={styles.keyFeatureIcon} />
            )}
            <p className={styles.keyFeatureDescription}>{description}</p>
          </div>
        )
      })}
    </div>
  )
}

export default ChallanKeyFeatures
